import React from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue, sumArray } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebSocialToSitePage: React.FC = () => {
  const socialToSite = analyticsSnapshot.crossChannelAnalysis.socialToSite;
  const socialInsights = analyticsSnapshot.aiAnalysis.crossChannelAnalysis.socialToSite;

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-3xl font-bold text-white">Sosyal medyadan Siteye Akış</h1>
        <p className="text-white/70 mt-2">
          Sosyal medya kanallarından gelen trafik ve gelir katkısını izleyerek kampanya yatırımlarını optimize edin.
        </p>
      </div>

      {socialToSite.map((channelData) => {
        type ChannelDataset = { label: string; data: readonly number[] };
        const datasets = channelData.datasets as ReadonlyArray<ChannelDataset>;
        const channelInsights =
          socialInsights.find((item) => item.channel === channelData.channel)?.insights ?? [];

        const clicksDataset = datasets.find((dataset) => dataset.label === 'SocialClicks');
        const revenueDataset = datasets.find((dataset) => dataset.label === 'SocialRevenue');

        const latestClicks = clicksDataset ? findLatestValue(clicksDataset.data) : { value: null, index: -1 };
        const latestRevenue = revenueDataset ? findLatestValue(revenueDataset.data) : { value: null, index: -1 };
        const label =
          latestClicks.index >= 0 ? channelData.labels[latestClicks.index] : channelData.labels.at(-1) ?? 'Veri yok';
        const chartData: ChartData<'bar'> = {
          labels: Array.from(channelData.labels),
          datasets: datasets.map((dataset) => ({
            label: dataset.label === 'SocialRevenue' ? 'Gelir (USD)' : 'Tıklama',
            data: Array.from(dataset.data)
          }))
        };

        return (
          <section key={channelData.channel} className="space-y-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h2 className="text-2xl font-semibold text-white">{channelData.channel}</h2>
                <p className="text-white/60 text-sm">
                  Sosyal kampanyalardan gelen son dönem trafik ve gelir performansı.
                </p>
              </div>
              <div className="text-sm text-white/40">
                Son veri: <span className="text-white/70">{label}</span>
              </div>
            </div>

            <ChartCard
              title={`${channelData.channel} Trendleri`}
              description="Sosyal medya kampanyalarının trafik ve gelir performansı."
              chartType="bar"
              data={chartData}
              insights={channelInsights ?? []}
              footer={
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                  <MetricSummary
                    title="Toplam Tıklama"
                    value={clicksDataset ? sumArray(clicksDataset.data) : null}
                    description="Yıl içindeki toplam yönlendirme tıklamaları."
                  />
                  <MetricSummary
                    title="Toplam Gelir"
                    value={revenueDataset ? sumArray(revenueDataset.data) : null}
                    unit="currency"
                    currency="USD"
                    description="Sosyal medya kaynaklı toplam gelir."
                  />
                  <MetricSummary
                    title="Son Ay Tıklama"
                    value={latestClicks.value}
                    description="Son ölçülen ay için yönlendirme."
                  />
                </div>
              }
            />

          </section>
        );
      })}
    </div>
  );
};

export default WebSocialToSitePage;

